import { Row, Col, Radio, Checkbox, Steps, Button, theme, Input, Select, Form, Alert } from 'antd';
import { useState } from 'react';
import { Helmet } from "react-helmet";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import { FaCircleCheck } from "react-icons/fa6";

export const Builderold = () => {

        const [ form ] = Form.useForm();
        const { token } = theme.useToken();
        const [current, setCurrent] = useState(0);
        const [ answers, setAnswers ] = useState({
                audience:       1,
                age:            [],
                agetype:        2,
                area:           2,
                miles:          50,
                place:          "Bristol",
                jobtitle:       "",
                trading:        1,
                tradingstart:   2024,
                offering:       2,
                producttype:    1,
                servicetype:    1,
                objective:      1,
                quantity:       50,
                frequency:      3,
                delivery:       2,
                value:          50,
                industry:       18,     
        })

        const [ passwordMessage, setPasswordMessage ] = useState(false)

        // useEffect( () => {

        //         let defaultValues = {
        //                 facebook:       15,
        //                 instagram:      15,
        //                 tiktok:         15,
        //                 linkedin:       15,
        //                 google:         20,
        //                 seo:            20,
        //         }

        //         if (answers.audience === 1) {
        //                 if (answers.agetype === 1 ) {
        //                         if (answers.age.includes('1') || answers.age.includes('2')) {

        //                                 setP({...defaultValues, tiktok: 60})

        //                         } else if (answers.age.includes('3') || answers.age.includes('4')) {

        //                                 setP({...defaultValues, tiktok: 40})

        //                         } else {

        //                                 delete defaultValues.tiktok;
        //                                 setP({...defaultValues})
        //                         }
        //                 } else {
        //                         setP({...defaultValues, facebook: 30, tiktok: 30})
        //                 }
                        
        //         } else if (answers.audience === 2) {
        //                 if (answers.area === 1) {

        //                         delete defaultValues.tiktok;
        //                         setP({...defaultValues, facebook: 15, instagram: 15, linkedin: 30})

        //                 } else {

        //                         delete defaultValues.tiktok;
        //                         setP({...defaultValues, facebook: 15, instagram: 15, linkedin: 50})
        //                         setP({
        //                                 ...defaultValues,
        //                                 facebook:       15,
        //                                 instagram:      15,
        //                                 tiktok:         15,
        //                                 linkedin:       15,
        //                                 google:         20
        //                         })
        //                 }
        //         }

        // }, [answers])

        const industries = [
                {"id": 18, "name": "Other"},
                {"id": 16, "name": "Automotive"},
                {"id": 1, "name": "Agriculture and Forestry"},
                {"id": 2, "name": "Construction and Real Estate"},
                {"id": 3, "name": "Consumer Goods and Retail"},
                {"id": 4, "name": "Education and Training"},
                {"id": 5, "name": "Energy and Utilities"},
                {"id": 6, "name": "Financial Services"},
                {"id": 17, "name": "Health & Fitness"},
                {"id": 7, "name": "Healthcare and Pharmaceuticals"},
                {"id": 8, "name": "Hospitality and Tourism"},
                {"id": 9, "name": "Information Technology and Telecommunications"},
                {"id": 10, "name": "Manufacturing and Engineering"},
                {"id": 11, "name": "Media, Entertainment, and Arts"},
                {"id": 12, "name": "Non-Profit and Government"},
                {"id": 13, "name": "Professional Services"},
                {"id": 14, "name": "Transport and Logistics"},
                {"id": 15, "name": "Environmental and Green Technologies"}
              ]
        
        const next = () => {
                setCurrent(current + 1);
              };
              const prev = () => {
                setCurrent(current - 1);
              };

        const banner = () => {

                return (
                        <div id="builder-banner">
                                <div className="container">
                                        {/* <Row gutter={15} align="middle">
                                                <Col sm={24}>
                                                        <div className="heroText">
                                                                <h1>Package Builder</h1>
                                                                <h4>Answer the questions below to build your custom SmartPromote package</h4>
                                                        </div>
                                                </Col>
                                               
                                        </Row> */}
                                        
                                        
                                        
                                </div>
                        </div>
                )
        }

        

        const contentStyle = {
                // lineHeight: '260px',
                textAlign: 'left',
                // padding: '20px 50px',
                // color: token.colorTextTertiary,
                backgroundColor: token.colorFillAlter,
                borderRadius: token.borderRadiusLG,
                // border: `1px dashed ${token.colorBorder}`,
                marginTop: 16,
        };

        const audience = () => {

                return (
                        <Row>
                                <Col sm={24}>
                                        <div style={{backgroundColor: 'white', padding: '20px 50px'}}>
                                                <Row gutter={15}>
                                                        <Col sm={12}>
                                                                <div className="option">
                                                                        <h3>Audience</h3>
                                                                        <p>
                                                                                What type of clients are you looking to target?
                                                                        </p>
                                                                        <Radio.Group
                                                                                onChange={(e) => setAnswers({...answers, audience: e.target.value}) }
                                                                                value={answers.audience}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Consumers", value: 1 },
                                                                                        { label:  "Businesses", value: 2 },
                                                                                        // { label:  "Businesses & Consumers", value: 3 },
                                                                                ]}
                                                                        />
                                                                </div>
                                                                { answers.audience === 2 &&
                                                                <>
                                                                        <h3>Job Titles</h3>
                                                                        <p>
                                                                                Enter any job titles the decision makers might have
                                                                        </p>
                                                                        <Input placeholder="e.g. Senior management, buyers, owners, etc." onChange={ (e) => setAnswers({...answers, jobtitle: e.target.value}) } value={answers.jobtitle} style={{marginBottom: 10}}/>
                                                                </>}
                                                                { answers.audience === 1 &&
                                                                <div className="option" style={{marginTop: 50}}>
                                                                        <h3>Age Profile</h3>
                                                                        <p>
                                                                                Select the age ranges that apply to your perfect customer
                                                                        </p>
                                                                        <Radio.Group
                                                                                onChange={(e) => setAnswers({...answers, agetype: e.target.value}) }
                                                                                value={answers.agetype}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Age groups", value: 1 },
                                                                                        { label:  "Anyone with an interest", value: 2 },
                                                                                        // { label:  "Businesses & Consumers", value: 3 },
                                                                                ]}
                                                                        />
                                                                        { answers.agetype === 1 &&
                                                                        <Checkbox.Group 
                                                                                onChange={(e) => setAnswers({...answers, age: e}) }
                                                                                value={answers.age} style={{width: '100%', marginTop: 20}}>
                                                                        <Row>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="1">Under 18</Checkbox>
                                                                                </Col>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="2">18 - 29 Years old</Checkbox>
                                                                                </Col>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="3">30 - 39 Years old</Checkbox>
                                                                                </Col>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="4">40 - 49 Years old</Checkbox>
                                                                                </Col>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="5">50 - 59 Years old</Checkbox>
                                                                                </Col>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="6">60 - 69 Years old</Checkbox>
                                                                                </Col>
                                                                                <Col span={12} style={{marginBottom: 10}}>
                                                                                        <Checkbox value="7">70+ Years old</Checkbox>
                                                                                </Col>
                                                                        </Row>
                                                                </Checkbox.Group> }
                                                                </div> }
                                                        </Col>
                                                        <Col sm={12}>
                                                                <div className="option">
                                                                        <h3>Location</h3>
                                                                        <p>
                                                                                Where do your audience live or work?
                                                                        </p>
                                                                        <Radio.Group
                                                                                onChange={(e) => setAnswers({...answers, area: e.target.value}) }
                                                                                value={answers.area}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Location Radius", value: 1 },
                                                                                        { label:  "Nationally", value: 2 },
                                                                                ]}
                                                                        />
                                                                        { answers.area === 1 &&
                                                                        <Row gutter={15}>
                                                                                <Col sm={24}>
                                                                                        <Input onChange={ (e) => setAnswers({...answers, miles: e.target.value}) } value={answers.miles} style={{width: 150, marginTop: 10}} type="number" suffix="Miles"/>
                                                                                </Col>
                                                                                <Col sm={24}>
                                                                                        From <Input onChange={ (e) => setAnswers({...answers, place: e.target.value}) } value={answers.place} style={{width: 200, marginTop: 10}}/>
                                                                                </Col>
                                                                        </Row>
                                                                        }
                                                                </div>
                                                        </Col>
                                                </Row>
                                        

                                                
                                        
                                         
                                </div>
                                </Col>
                                {/* <Col sm={12}>
                                        { results() }
                                </Col> */}
                        </Row>
                        
                )
        }

        const goals = () => {

                return (
                        <Row>
                                <Col sm={24}>
                                        <div style={{backgroundColor: 'white', padding: '20px 50px'}}>
                                                <Row gutter={15}>
                                                        <Col sm={12}>
                                                                <div className="option">
                                                                        <h3>Objectives</h3>
                                                                        <p>
                                                                                What does your business need more of?
                                                                        </p>
                                                                        <Radio.Group
                                                                                value={answers.objective}
                                                                                onChange={ (v) => setAnswers(
                                                                                        {
                                                                                                ...answers, 
                                                                                                objective: v.target.value,
                                                                                                quantity: v.target.value === 1 ? 50 : v.target.value === 2 ? 25 : 10
                                                                                        }) }
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Enquiries", value: 1 },
                                                                                        { label:  "Leads", value: 2 },
                                                                                        { label:  "Sales", value: 3 },
                                                                                ]}
                                                                        />
                                                                </div>
                                                        </Col>
                                                        <Col sm={12}>
                                                                { answers.objective < 3 &&
                                                                <div className="option">
                                                                        <h3>Delivery</h3>
                                                                        <p>
                                                                                Ideally how should your {answers.objective === 1 ? "enquiries" : "leads"} be delivered?
                                                                        </p>
                                                                        <Radio.Group
                                                                                value={answers.delivery}
                                                                                onChange={ (v) => setAnswers(
                                                                                        {
                                                                                                ...answers, 
                                                                                                delivery: v.target.value,
                                                                                        }) }
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Email", value: 1 },
                                                                                        { label:  "Phone calls", value: 2 },
                                                                                        { label:  "Website forms", value: 3 },
                                                                                ]}
                                                                        />
                                                                        
                                                                </div>  }

                                                                { answers.objective === 3 &&
                                                                <div className="option">
                                                                        <h3>Sales value</h3>
                                                                        <p>
                                                                                What's the average value of a sale worth to your business?
                                                                        </p>
                                                                        
                                                                        <Input onChange={ (e) => setAnswers({...answers, value: e.target.value}) } value={answers.value} style={{width: 250}} type="number" prefix={"£"}/>
                                                                </div>  }
                                                        </Col>
                                                </Row>
                                                
                                                
                                                
                                                <div className="option">
                                                        <h3>Quantity</h3>
                                                        <p>
                                                                What does success look like?
                                                        </p>
                                                        
                                                        <Input onChange={ (e) => setAnswers({...answers, quantity: e.target.value}) } value={answers.quantity} style={{width: 250}} type="number" suffix={answers.objective === 1 ? 'Enquiries' : answers.objective === 2 ? "Leads" : "Sales"}/>
                                                        <div style={{marginTop: 20}}>
                                                        <Radio.Group
                                                                value={answers.frequency}
                                                                onChange={ (v) => setAnswers(
                                                                        {
                                                                                ...answers, 
                                                                                frequency: v.target.value,
                                                                        }) }
                                                                optionType='button'
                                                                buttonStyle='solid'
                                                                options={[
                                                                        { label:  "Per day", value: 1 },
                                                                        { label:  "Per week", value: 2 },
                                                                        { label:  "Per month", value: 3 },
                                                                ]}
                                                        /></div>
                                                </div> 
                                        </div>
                                </Col>
                        </Row>
                )
        }

        const you = () => {

                return (
                        <Row>
                                <Col sm={24}>
                                        <div style={{backgroundColor: 'white', padding: '20px 50px'}}>
                                                <div className="option">
                                                        <h3>Industry</h3>
                                                        <p>
                                                                Please search and select the industry you work in
                                                        </p>
                                                        <Select 
                                                                value={answers.industry}
                                                                onChange={(v) => setAnswers({...answers, industry: v})}
                                                                showSearch
                                                                placeholder="Select an industry"
                                                                optionFilterProp="children"
                                                                style={{width: '100%'}}>
                                                                { industries.map((ind, i) => <Select.Option key={i} value={ind.id}>{ind.name}</Select.Option>)}
                                                        </Select>
                                                </div>
                                                <Row gutter={15}>
                                                        <Col sm={12}>
                                                                <div className="option">
                                                                        <h3>Trading status</h3>
                                                                        <p>
                                                                                Are you currently trading?
                                                                        </p>
                                                                        <Radio.Group
                                                                                value={answers.trading}
                                                                                onChange={(v) => setAnswers({...answers, trading: v.target.value})}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "No", value: 2 },
                                                                                        { label:  "Yes", value: 1 },
                                                                                ]}
                                                                        />
                                                                </div>
                                                        </Col>
                                                        <Col sm={12}>
                                                                { answers.trading === 1 &&
                                                                <div className="option">
                                                                        <h3>Start year</h3>
                                                                        <p>
                                                                                What year did you start?
                                                                        </p>
                                                                        { answers.trading === 1 &&
                                                                        <Input onChange={ (e) => setAnswers({...answers, tradingstart: e.target.value}) } value={answers.tradingstart} style={{width: 250}} type="number"/>}
                                                                </div> }
                                                        </Col>
                                                </Row>
                                                <Row gutter={15}>
                                                        <Col sm={12}>
                                                                <div className="option">
                                                                        <h3>What do you offer?</h3>
                                                                        <p>
                                                                                What are you offering your audience?
                                                                        </p>
                                                                        <Radio.Group
                                                                                value={answers.offering}
                                                                                onChange={(v) => setAnswers({...answers, offering: v.target.value})}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Products", value: 1 },
                                                                                        { label:  "Services", value: 2 },
                                                                                ]}
                                                                        />
                                                                </div>
                                                        </Col>
                                                        <Col sm={12}>
                                                                { answers.offering === 1 &&
                                                                <div className="option">
                                                                        <h3>Product type</h3>
                                                                        <p>
                                                                                What type of products do you sell?
                                                                        </p>
                                                                        <Radio.Group
                                                                                value={answers.producttype}
                                                                                onChange={(v) => setAnswers({...answers, producttype: v.target.value})}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "Physical products", value: 1 },
                                                                                        { label:  "Digital products", value: 2 },
                                                                                ]}
                                                                        />
                                                                </div>}
                                                                { answers.offering === 2 &&
                                                                <div className="option">
                                                                        <h3>Service type</h3>
                                                                        <p>
                                                                                What type of services do you offer?
                                                                        </p>
                                                                        <Radio.Group
                                                                                value={answers.servicetype}
                                                                                onChange={(v) => setAnswers({...answers, servicetype: v.target.value})}
                                                                                optionType='button'
                                                                                buttonStyle='solid'
                                                                                options={[
                                                                                        { label:  "In-person services", value: 1 },
                                                                                        { label:  "Digital services", value: 2 },
                                                                                ]}
                                                                        />
                                                                </div>}
                                                        </Col>
                                                </Row>
                                                

                                                
                                        </div>
                                </Col>
                                
                        </Row>
                )
        }

        
        const [ selected, setSelected ] = useState(2)

        const investment = () => {

                return (
                        <Row>
                                <Col sm={24}>
                                        <div style={{backgroundColor: 'white', padding: '20px 50px'}}>
                                                <div className="option">
                                                        <h3>Choose your investment level</h3>
                                                        {/* <p>
                                                                Based on your answers, we've calculated the following investment levels.
                                                        </p> */}
                                                        <Row gutter={15}>
                                                                <Col sm={8}>
                                                                        <div onClick={() => setSelected(1) } className={`package ${selected === 1 ? "selected" : ""}`}>
                                                                                { selected === 1 && <div className="checked"><FaCircleCheck color="#5E4EE0" size={40} /></div> }
                                                                                <Row gutter={15} type="flex">
                                                                                        <Col sm={24}>
                                                                                                <div className="name">
                                                                                                        <h5>Starter</h5>
                                                                                                        <ul>
                                                                                                                <li><FiCheck color="green"/> Manage Ad campaigns</li>
                                                                                                                <li><FiCheck color="green"/> Run social accounts</li>
                                                                                                                <li><FiCheck color="green"/> Website management</li>
                                                                                                                <li><FiCheck color="green"/> Regular content</li>
                                                                                                                <li><FiCheck color="green"/> Graphic design</li>
                                                                                                                <li><FiCheck color="green"/> Boost search rankings</li>
                                                                                                                <li><FiCheck color="green"/> Monthly optimisation</li>
                                                                                                        </ul>
                                                                                                </div>
                                                                                        </Col>
                                                                                        <Col sm={24}>
                                                                                                <div className="priceArea">
                                                                                                        <div className="price">
                                                                                                                Search Ad spend: £585
                                                                                                        </div>
                                                                                                        <div className="price">
                                                                                                                Social Ad spend: £385
                                                                                                        </div>
                                                                                                        <div className="price">
                                                                                                                Management: £500
                                                                                                        </div>
                                                                                                        <br/>
                                                                                                        
                                                                                                        <div className="price">
                                                                                                                <div className="total">
                                                                                                                £885
                                                                                                                </div>
                                                                                                                {/* <Button type="package">Save Package</Button>   */}
                                                                                                        </div>
                                                                                                </div>
                                                                                        </Col>
                                                                                </Row>
                                                                        </div>
                                                                </Col>
                                                                <Col sm={8}>
                                                                        <div onClick={() => setSelected(2) } className={`package ${selected === 2 ? "selected" : ""}`}>
                                                                                { selected === 2 && <div className="checked"><FaCircleCheck color="#5E4EE0" size={40} /></div> }
                                                                                <Row gutter={15} type="flex">
                                                                                        <Col sm={24}>
                                                                                                <div className="name">
                                                                                                        <h5>Advanced</h5>
                                                                                                        <ul>
                                                                                                                <li><FiCheck color="green"/> Manage Ad campaigns</li>
                                                                                                                <li><FiCheck color="green"/> Run social accounts</li>
                                                                                                                <li><FiCheck color="green"/> Website management</li>
                                                                                                                <li><FiCheck color="green"/> Regular content</li>
                                                                                                                <li><FiCheck color="green"/> Graphic design</li>
                                                                                                                <li><FiCheck color="green"/> Boost search rankings</li>
                                                                                                                <li><FiCheck color="green"/> Weekly optimisation</li>
                                                                                                        </ul>
                                                                                                </div>
                                                                                        </Col>
                                                                                        <Col sm={24}>
                                                                                                <div className="priceArea">
                                                                                                <div className="price">
                                                                                                                Search Ad spend: £585
                                                                                                        </div>
                                                                                                        <div className="price">
                                                                                                                Social Ad spend: £385
                                                                                                        </div>
                                                                                                        <div className="price">
                                                                                                                Management: £700
                                                                                                        </div>
                                                                                                        <br/>
                                                                                                        
                                                                                                        <div className="price">
                                                                                                                <div className="total">
                                                                                                                £1,185
                                                                                                                </div>
                                                                                                                {/* <Button type="package">Save Package</Button>   */}
                                                                                                        </div>
                                                                                                </div>
                                                                                        </Col>
                                                                                </Row>
                                                                        </div>
                                                                </Col>
                                                                <Col sm={8}>
                                                                        <div onClick={() => setSelected(3) } className={`package ${selected === 3 ? "selected" : ""}`}>
                                                                                { selected === 3 && <div className="checked"><FaCircleCheck color="#5E4EE0" size={40} /></div> }
                                                                                <Row gutter={15} type="flex">
                                                                                        <Col sm={24}>
                                                                                                <div className="name">
                                                                                                        <h5>Ultra</h5>
                                                                                                        <ul>
                                                                                                                <li><FiCheck color="green"/> Manage Ad campaigns</li>
                                                                                                                <li><FiCheck color="green"/> Run social accounts</li>
                                                                                                                <li><FiCheck color="green"/> Website management</li>
                                                                                                                <li><FiCheck color="green"/> Regular content</li>
                                                                                                                <li><FiCheck color="green"/> Graphic design</li>
                                                                                                                <li><FiCheck color="green"/> Boost search rankings</li>
                                                                                                                <li><FiCheck color="green"/> Weekly optimisation</li>
                                                                                                        </ul>
                                                                                                </div>
                                                                                        </Col>
                                                                                        <Col sm={24}>
                                                                                                <div className="priceArea">
                                                                                                <div className="price">
                                                                                                                Search Ad spend: £585
                                                                                                        </div>
                                                                                                        <div className="price">
                                                                                                                Social Ad spend: £385
                                                                                                        </div>
                                                                                                        <div className="price">
                                                                                                                Management: £800
                                                                                                        </div>
                                                                                                        <br/>
                                                                                                        
                                                                                                        <div className="price">
                                                                                                                <div className="total">
                                                                                                                £1,685
                                                                                                                </div>
                                                                                                        {/* <Button type="package">Save Package</Button>   */}
                                                                                                        </div>
                                                                                                </div>
                                                                                        </Col>
                                                                                </Row>
                                                                        </div>
                                                                </Col>
                                                        </Row>
                                                        
                                                        
                                                        
                                                </div>
                                        </div>
                                </Col>
                                
                        </Row>
                )
        }

        const checkPassword = () => {

                const messages = {
                        match:  "Passwords do not match",
                        short:  "Password must be at least 6 characters"
                }

                const p = form.getFieldValue("passwordCheck")
                const password = form.getFieldValue("password")

                if (password.length > 0 && password.length < 6) { setPasswordMessage(messages.short); return }
                if (p.length > 0 && p !== password) { setPasswordMessage("Passwords do not match"); return }

                setPasswordMessage(false)
        }
        const savePackage = () => {

                return (
                        <Row>
                                <Col sm={24}>
                                        <div style={{backgroundColor: 'white', textAlign: 'center', padding: '20px 50px'}}>
                                                <h3>Your package has been saved</h3>
                                                <h2>#P113433</h2>

                                                <div className="savePackage">
                                                        <Form form={form} layout="vertical">
                                                                <Form.Item name="email" label="Email address">
                                                                        <Input />
                                                                </Form.Item>
                                                                <Form.Item name="password" label="Password">
                                                                        <Input type="password"  onChange={(e) => checkPassword() }/>
                                                                </Form.Item>
                                                                <Form.Item name="passwordCheck" label="Confirm password">
                                                                        <Input type="password" onChange={(e) => checkPassword() } />
                                                                </Form.Item>
                                                                { passwordMessage &&
                                                                <Alert type="error" message={passwordMessage} />
                                                                }
                                                        </Form>
                                                </div>
                                                <div className="buttons">
                                                        <Button 
                                                                style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                        }} type="primary">Create Your Account <FiArrowRight style={{marginLeft: 5}}/> </Button>
                                                        
                                                </div>
                                                
                                        </div>
                                </Col>
                                
                        </Row>
                )
        }
        
        const steps = [
                {
                        title: 'Audience',
                        content: audience(),
                },
                {
                        title: 'About you',
                        content: you(),
                },
                {
                        title: 'Goals',
                        content: goals(),
                },
                {
                        title: 'Investment',
                        content: investment(),
                },
                {
                        title: 'Save',
                        content: savePackage(),
                },
        ];

        const items = steps.map((item) => ({
                key: item.title,
                title: item.title,
        }));

        return (
                <>
                <Helmet>
                        <meta charSet="utf-8" />
                        <title>Package Builder</title>
                </Helmet>
                <div className="page">
                        { banner() }
                        <div className="section grey">
                                <div className="container">

                                        <Row gutter={15} align="center">
                                                <Col lg={20} xs={16}>
                                                        <Steps current={current} items={items} />

                                                        <div style={contentStyle}>{steps[current].content}</div>
                                                        <div style={{marginTop: 24, textAlign: 'right'}}>
                                                                {current > 0 &&  (<Button style={{margin: '0 8px',}}onClick={() => prev()}>Previous</Button>)} 
                                                                {current < steps.length - 1 && (<Button type="primary" onClick={() => next()}>Next</Button>)}
                                                                {/* {current === steps.length - 1 && (<Button type="primary" onClick={() => message.success('Processing complete!')}>Save Package</Button>)} */}
                                                                
                                                        </div>
                                                </Col>
                                        </Row>
                                        
                                        
                                        <Row gutter={15}>
                                                <Col sm={12}>
                                                        

                                                        
                                                </Col>
                                        </Row>
                                        
                                        
                                </div>
                        </div>
                </div>
                </>
        )
}